import React, { useEffect, useState } from 'react'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__cameraSettings.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import { SwitchButton } from '../../../atoms/SwitchButton'
import { Typography } from '../../../atoms/Typography'
import grid from '../../../blocks.simple/grid/grid.jcss'
import { Radio } from '../../../atoms/Radio'
import Button from '../../../blocks.simple/button/button'

export const CameraSettings = (p_: {
    cameras: any
    className?: string | object
    onChange: (data: any) => void
    enabled: boolean
}) => {
    const [cameras, setCameras] = useState(p_.cameras || [])

    const onDataChange = (changeItemIndex: number, value: any, type: string) => {
        p_.onChange(
            cameras.map((camera: any, index: number) => {
                if (changeItemIndex === index) {
                    return { ...camera, [type]: value }
                }
                return camera
            })
        )
    }
    const addCamera = () => {
        setCameras([{ name: '', sourceId: '' }, ...cameras])
    }

    useEffect(() => {
        if (p_.cameras && p_.cameras.length) {
            setCameras(p_.cameras)
        }
    }, [p_.cameras])

    return (
        <div className={cn(p_.className)}>
            <div className={cn(grid.mt_micro, grid.mb_md)}>{translate('cameraSettings')}:</div>
            <Button className={cn(grid.mb_md)} mod="fill" onClick={addCamera}>
                {translate('addCamera')}
            </Button>

            {Array.isArray(cameras) &&
                cameras.map((camera: any, index: number) => (
                    <div className={cn(styles.border, grid.mb_md)} key={`camera_${index}`}>
                        <div className={cn(styles.wrapper)}>
                            <EditText
                                mod={'withBorder'}
                                className={styles.input}
                                label={translate('cameraName')}
                                value={camera.name}
                                onChange={(e: string) => {
                                    onDataChange(index, e, 'name')
                                }}
                            />
                        </div>
                        <div className={cn(styles.wrapper)}>
                            <EditText
                                mod={'withBorder'}
                                className={styles.input}
                                label={translate('cameraId')}
                                value={camera.sourceId}
                                onChange={(e: string) => {
                                    onDataChange(index, e, 'sourceId')
                                }}
                            />
                        </div>
                    </div>
                ))}
        </div>
    )
}
